import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_3'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_3',
  name: 'Does the facility have any of the following safety measures in place related to the emergency alarm system?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EMERGENCY_ALARM_SYSTEM_IS_FULLY_FUNCTIONING',
      text: 'Emergency alarm system is fully functioning',
      externalIds: [
        {
          id: 'hs-19--5-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_ALARM_SYSTEM_IS_REGULARLY_MAINTAINED_AND_INSPECTED_TE',
      text: 'Emergency alarm system is regularly maintained and inspected/ tested',
      externalIds: [
        {
          id: 'hs-19--5-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_ALARM_SYSTEM_CAN_BE_HEARD_AND_SEEN_ACROSS_ALL_FACILIT',
      text: 'Emergency alarm system can be heard and seen across all facility areas',
      externalIds: [
        {
          id: 'hs-19--5-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_ALARM_SYSTEM_BUTTONS_SWITCHES_PULL_STATIONS_ARE_EASIL',
      text: 'Emergency alarm system buttons/switches/pull stations are easily identified and accessible',
      externalIds: [
        {
          id: 'hs-19--5-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_ALARM_SYSTEM_IS_FITTED_WITH_A_BACK_UP_POWER_SOURCE_E_',
      text: 'Emergency alarm system is fitted with a back-up power source (e.g., battery back-up)',
      externalIds: [
        {
          id: 'hs-19--5-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_ALARM_SYSTEM_IS_AUTOMATIC_AND_CENTRALIZED',
      text: 'Emergency alarm system is automatic and centralized',
      externalIds: [
        {
          id: 'hs-19--5-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'EMERGENCY_ALARM_IS_DISTINCT_FROM_OTHER_ALARMS_SIGNALS_AND_IS_NO',
      text: 'Emergency alarm is distinct from other alarms/signals and is not used for any other purpose',
      externalIds: [
        {
          id: 'hs-19--5-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-19--5-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'EMERGENCY_ALARM_SYSTEM_IS_FULLY_FUNCTIONING',
                'EMERGENCY_ALARM_SYSTEM_IS_REGULARLY_MAINTAINED_AND_INSPECTED_TE',
                'EMERGENCY_ALARM_SYSTEM_CAN_BE_HEARD_AND_SEEN_ACROSS_ALL_FACILIT',
                'EMERGENCY_ALARM_SYSTEM_BUTTONS_SWITCHES_PULL_STATIONS_ARE_EASIL',
                'EMERGENCY_ALARM_SYSTEM_IS_FITTED_WITH_A_BACK_UP_POWER_SOURCE_E_',
                'EMERGENCY_ALARM_SYSTEM_IS_AUTOMATIC_AND_CENTRALIZED',
                'EMERGENCY_ALARM_IS_DISTINCT_FROM_OTHER_ALARMS_SIGNALS_AND_IS_NO',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-eme-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14630,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
